import {
  Card,
  CardContent,
  CardHeader,
} from "../../../../../shared/components/card/Card";
import { Skeleton } from "../../../../../shared/components/skeleton/Skeleton";

const DatasetSkeleton = () => {
  return (
    <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <Skeleton className="h-6 w-3/4 mb-2 bg-gray-200 dark:bg-gray-700" />
            <Skeleton className="h-4 w-full mb-1 bg-gray-200 dark:bg-gray-700" />
            <Skeleton className="h-4 w-2/3 mb-3 bg-gray-200 dark:bg-gray-700" />
          </div>
          <div className="flex flex-col items-end gap-2 ml-3">
            <Skeleton className="h-5 w-16 rounded-full bg-gray-200 dark:bg-gray-700" />
            <Skeleton className="h-5 w-12 rounded-full bg-gray-200 dark:bg-gray-700" />
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4 bg-gray-200 dark:bg-gray-700" />
              <Skeleton className="h-4 w-20 bg-gray-200 dark:bg-gray-700" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4 bg-gray-200 dark:bg-gray-700" />
              <Skeleton className="h-4 w-24 bg-gray-200 dark:bg-gray-700" />
            </div>
          </div>

          <Skeleton className="h-8 w-full mt-4 bg-gray-200 dark:bg-gray-700" />
        </div>
      </CardContent>
    </Card>
  );
};

export default DatasetSkeleton;
